import React from "react";
import {
	createSmokingHistory,
	getUserSettings,
	saveSmokingHistory,
} from "../../services/userService";
import { Switch, Route, Redirect } from "react-router-dom";
import { Page1 } from "./SmokingHistory/Page1";
import { Page2 } from "./SmokingHistory/Page2";

export const pathRoot = "/setupdata/smokinghistory";

export function finishSmokingHistory(smokingHistory) {
	return new Promise((resolve, reject) => {
		if (!smokingHistory) {
			return resolve();
		}

		smokingHistory.complete = true;

		saveSmokingHistory(smokingHistory).then(resolve).catch(reject);
	});
}

class SmokingHistory extends React.Component {
	constructor(props) {
		super(props);
		const smokingHistory =
			getUserSettings().smokingHistory ?? createSmokingHistory();

		this.state = {
			smokingHistory: smokingHistory,
		};
	}

	render() {
		return (
			<>
				<Switch>
					<Route path={`${pathRoot}/1`}>
						<Page1 smokingHistory={this.state.smokingHistory} />
					</Route>
					<Route path={`${pathRoot}/2`}>
						<Page2 smokingHistory={this.state.smokingHistory} />
					</Route>
					<Redirect exact from={pathRoot} to={`${pathRoot}/1`}></Redirect>
				</Switch>
			</>
		);
	}
}

export { SmokingHistory };
